import OrderableModel from '@/models/OrderableModel';

export default class CustomField extends OrderableModel {
    get route () {
        return 'custom-fields';
    }

    get storePrimaryKey () {
        return 'name';
    }

    static get className () {
        return 'CustomField';
    }

    static get isInStore () {
        return true;
    }
}
